module.exports = __webpack_public_path__ + "img/c01.713a6cb8.png";